import { render } from "./mega10.vue?vue&type=template&id=c8c132c4&scoped=true"
import script from "./mega10.vue?vue&type=script&lang=js"
export * from "./mega10.vue?vue&type=script&lang=js"

import "./mega10.vue?vue&type=style&index=0&id=c8c132c4&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c132c4"]])

export default __exports__